/*
    16301: SMALL
    16302: REGULAR
    16303: REGULAR TALL
    16304: PREMIUM
    16305: PREMIUM TALL
*/

import axios from "axios";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import ShowCaseGrid from "./ShowCaseGrid";
import ShowCaseModal from "./ShowCaseModal";
import ShowCaseLoading from "./ShowCaseLoading";
import ShowCaseError from "./ShowCaseError";
import ShowCaseTitle from "./ShowCaseTitle";
import { Analytics, ShowcaseAnalytics } from "./Analytics";

Modal.setAppElement("body");

const ShowCase = ({ restUrl }) => {
    // const URL = `/api/solr?filters={"featured_type":"(16268 OR 16274 OR 16275 OR 16276 OR 16277 OR 16278) OR featured_type_varchar:(16268 OR 16274 OR 16275 OR 16276 OR 16277 OR 16278)"}`;
    const URL = `/api/solr?filters={"featured_type": "(16301 OR 16302 OR 16303 OR 16304 OR 16305) OR featured_type_varchar:(16301 OR 16302 OR 16303 OR 16304 OR 16305)"}&sort=updated_at desc`;
    const [showCaseState, setShowCaseState] = useState({
        loading: true,
        items: null,
        error: false,
        showModal: false,
        currentItem: null
    });
    const { items, showModal, error, currentItem, loading } = showCaseState;

    const handleOpenModal = sku => {
        let currentModalItem = null;

        if (sku !== null) {
            currentModalItem = items.filter(i => i.sku === sku);
        }
        setShowCaseState({
            ...showCaseState,
            showModal: true,
            currentItem: currentModalItem
        });

        // Push click event to Google Tag Manager
        Analytics.click(ShowcaseAnalytics.makeMosaicEventProperties(currentModalItem[0]));
    };

    const handleCloseModal = () => {
        setShowCaseState({
            ...showCaseState,
            showModal: false,
            currentItem: null
        });
    };

    // turn random shuffle SCRIPT | https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    // const shuffle = (a) => {
    //     for (let i = a.length - 1; i > 0; i--) {
    //         const j = Math.floor(Math.random() * (i + 1));

    //         [a[i], a[j]] = [a[j], a[i]];
    //     }
    //     return a;
    // };

    useEffect(() => {
        axios
            .get(URL)
            .then(data => {
                setShowCaseState({
                    ...showCaseState,
                    items: data.data.response.result,  // turn random shuffle OFF
                    // items: shuffle(data.data.response.result), // turn random shuffle ON
                    error: false,
                    loading: false
                });
            })
            .catch(err => {
                setShowCaseState({
                    ...showCaseState,
                    error: true,
                    loading: false
                });
                console.error(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loading) return <ShowCaseLoading loading={loading} />;
    if (error || items === null) return <ShowCaseError />;
    return (
        <div className="cms cms--showcase">
            <div className="container">
                <ShowCaseTitle title="LabX.com Showcase" />
                <div className="directory">
                    <ShowCaseGrid
                        data={items}
                        restUrl={restUrl}
                        handleOpenModal={handleOpenModal}
                    />
                    <Modal
                        closeTimeoutMS={700}
                        isOpen={showModal}
                        contentLabel="LabX.com Showcase"
                        className="showcase-modal"
                        overlayClassName="showcase-overlay"
                    >
                        <div
                            onClick={handleCloseModal}
                            className="showcase-close"
                        >
                            <i className="fas fa-times" aria-hidden="true"></i>
                            <span className="sr-only">Close ShowCase Modal</span>
                        </div>
                        <ShowCaseModal item={currentItem} restUrl={restUrl} />
                    </Modal>
                </div>
            </div>
        </div>
    );
};

ShowCase.defaultProps = {
    restUrl: ""
};

ShowCase.propTypes = {
    restUrl: PropTypes.string.isRequired
};

export default ShowCase;
